const styles = (theme) => ({
  dialogPaper: {
    borderRadius: "16px",
    backgroundColor: "#F8F9FA",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(2, 3),
    borderBottom: "1px solid #E0E0E0",
    backgroundColor: "#FFFFFF",
    borderRadius: "16px 16px 0 0",
  },
  dialogTitle: {
    fontWeight: 700,
    color: "#2A3142",
  },
  dialogContent: {
    padding: 0,
    "&:first-child": {
      paddingTop: 0,
    },
  },
  themeFiltersContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(1),
    padding: theme.spacing(2, 3),
    backgroundColor: "#FFFFFF",
    borderBottom: "1px solid #F0F0F0",
    position: "sticky",
    top: 0,
    zIndex: 2,
    [theme.breakpoints.down("xs")]: {
      flexWrap: "nowrap",
      overflowX: "auto",
    },
  },
  themeButton: {
    borderRadius: "20px",
    textTransform: "none",
    fontWeight: 500,
    fontSize: "0.85rem",
    minHeight: "32px",
    padding: "4px 16px",
    flexShrink: 0,
    "&.Mui-focusVisible": {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: 2,
    },
  },
  themeButtonActive: {
    backgroundColor: "#2A3142",
    color: "#FFFFFF",
    border: "1px solid #2A3142",
    "&:hover": {
      backgroundColor: "#1a2030",
    },
  },
  themeButtonInactive: {
    backgroundColor: "#FFFFFF",
    color: "#555",
    border: "1px solid #E0E0E0",
    "&:hover": {
      backgroundColor: "#F5F5F5",
    },
  },
  toursGrid: {
    padding: theme.spacing(3),
  },
  tourCard: {
    backgroundColor: "#FFFFFF",
    borderRadius: "12px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    position: "relative",
    transition: "box-shadow 0.2s ease, transform 0.15s ease",
    height: "100%",
    "&:hover": {
      boxShadow: "0 6px 16px rgba(0, 0, 0, 0.12)",
      transform: "translateY(-2px)",
    },
  },
  tourCardImageWrapper: {
    position: "relative",
    width: "100%",
    height: "150px",
    overflow: "hidden",
  },
  tourCardImage: {
    width: "100%",
    height: "150px",
    objectFit: "cover",
    display: "block",
  },
  tourCardImagePlaceholder: {
    width: "100%",
    height: "150px",
    backgroundColor: "#C8D0DC",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  durationBadge: {
    position: "absolute",
    top: theme.spacing(1),
    right: theme.spacing(1),
    backgroundColor: "rgba(30, 30, 30, 0.75)",
    color: "#FFFFFF",
    borderRadius: "20px",
    padding: "2px 8px",
    display: "flex",
    alignItems: "center",
    gap: "4px",
    fontSize: "0.75rem",
    fontWeight: 600,
    backdropFilter: "blur(4px)",
  },
  infoButton: {
    position: "absolute",
    top: theme.spacing(0.75),
    left: theme.spacing(0.75),
    backgroundColor: "rgba(255, 255, 255, 0.88)",
    padding: "4px",
    width: "28px",
    height: "28px",
    backdropFilter: "blur(4px)",
    "&:hover": {
      backgroundColor: "#FFFFFF",
    },
  },
  themeBadge: {
    position: "absolute",
    bottom: theme.spacing(1),
    right: theme.spacing(1),
    backgroundColor: "rgba(40, 80, 200, 0.78)",
    color: "#FFFFFF",
    borderRadius: "6px",
    padding: "2px 8px",
    fontSize: "0.7rem",
    fontWeight: 600,
    maxWidth: "70%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    backdropFilter: "blur(4px)",
  },
  tourCardContent: {
    padding: theme.spacing(1.5, 1.5, 0.5),
    flexGrow: 1,
  },
  tourCardTitle: {
    fontWeight: 700,
    fontSize: "0.9rem",
    color: "#2A3142",
    lineHeight: 1.3,
    marginBottom: theme.spacing(0.5),
  },
  tourCardStats: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    padding: theme.spacing(0.5, 1.5, 1),
    flexWrap: "wrap",
  },
  statItem: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    color: "#6B7280",
    fontSize: "0.75rem",
    fontWeight: 500,
  },
  tourCardActions: {
    padding: theme.spacing(0, 1.5, 1.5),
  },
  copyButton: {
    textTransform: "none",
    borderRadius: "20px",
    width: "100%",
    backgroundColor: "#5E77FF",
    color: "#FFFFFF",
    fontWeight: 600,
    fontSize: "0.85rem",
    "&:hover": {
      backgroundColor: "#4a63e8",
    },
    "&:disabled": {
      backgroundColor: "#A0AABF",
      color: "#FFFFFF",
    },
  },
  requestButton: {
    textTransform: "none",
    borderRadius: "20px",
    width: "100%",
    backgroundColor: "#FF7043",
    color: "#FFFFFF",
    fontWeight: 600,
    fontSize: "0.85rem",
    "&:hover": {
      backgroundColor: "#e5622f",
    },
    "&:disabled": {
      backgroundColor: "#A0AABF",
      color: "#FFFFFF",
    },
  },
  descriptionPopover: {
    padding: theme.spacing(2),
    maxWidth: "280px",
  },
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing(6),
  },
  emptyState: {
    textAlign: "center",
    padding: theme.spacing(4),
    color: "#6B7280",
  },
  messagesContainer: {
    padding: theme.spacing(1, 3, 0),
  },
});

export default styles;
